import React, { useMemo } from "react";
import { connect, history, useLocation, useSelector } from "umi";
import {
  Layout,
  Tabs,
  TabPanel,
} from "tea-component";
import Insight from "./Insight/index";
import KeyMetrics from "./KeyMetrics/index";
import { useLocal } from '@/pages/dashboard/utils/customHook';
import "@/pages/dashboard/assets/scss/page/competitor/index.scss";
import './index.less';
import { getReqType } from "./_config/competitorRequest";
import { SubTitle } from "../../components/SubTitle";
import { ISelectorState } from "../../types/dashboard";

const { Body, Content } = Layout;
function Competitor(props: any) {
  const { getLocalText } = useLocal();

  const location = useLocation();
  const regex = /\/competitor\/([^/]+)/;
  const match = location.pathname.match(regex);
  const urlReqType = match ? match[1] : "index";
  const competitorReqType = getReqType(urlReqType);
  const dataFrame = useSelector((state: ISelectorState) => state?.dashboard?.currentGame?.data_frame || '');
  const isCasual = dataFrame === 'casual';

  const tabs = useMemo(() => {
    const baseTabs: any[] = [
      {
        id: "keyMetrics",
        label: getLocalText('competitor_tab_key_metrics'),
        component: <KeyMetrics competitorReqType={competitorReqType} urlReqType={urlReqType} isCasual={isCasual} />
      },
    ];
    if (!isCasual) {
      baseTabs.push({
        id: "insight",
        label: getLocalText('competitor_tab_insight'),
        component: <Insight competitorReqType={competitorReqType} urlReqType={urlReqType} />
      });
    }
    return baseTabs;
  }, [competitorReqType, urlReqType, isCasual]);

  const tabId = props?.match?.params?.tab || tabs[0]?.id;
  const onActive = (tab: { id: any; }) => {
    history.push(`/dashboard/game/${props.gameCode}/competitor/${urlReqType}/${tab.id}`);
  };

  return (
    <Layout>
      <Body>
        <Content className='dbd-scroll-body'>
          <Content.Header
            className={`dbd-competitor-header${isCasual ? ' dbd-competitor-header--no-tab' : ''}`}
            subtitle={<SubTitle />}
            title={competitorReqType === 'xh' ? (
              getLocalText('competitor_page_xh_title')
            ) : (
              getLocalText('competitor_page_title')
            )}

          >
            {!isCasual ? (
              <Tabs className="dbd-competitor-tab" animated={false} onActive={onActive} activeId={tabId} ceiling tabs={tabs}></Tabs>
            ) : null}
          </Content.Header>
          <Content.Body full className='dbd-competitor-body'>
            {isCasual ? (
              <KeyMetrics competitorReqType={competitorReqType} urlReqType={urlReqType} isCasual={isCasual} />
            ) : (
              tabs.map(item => {
                return item.id == tabId ? <TabPanel id={item.id} key={item.id} >
                  {item.component}
                </TabPanel> : "";
              })
            )}
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
}

export default connect((state: any) => ({
  gameCode: state.dashboard?.currentGame?.game_code,
}))(Competitor);
